(function ($) {

    $(function () {

        $('.fact-row .fact').each(function () {
            $(this).addViewportClass();
        });

        window.statisticAnimationFunction = function () {
            $(".statistics-callout-row .statistic-card").each(function () {
                var scrollBottom = $(window).scrollTop() + $(window).height();
                var elementMiddle = $(this).offset().top + ($(this).height() / 2);
                if (!$(this).hasClass("revealed")) {
                    if (scrollBottom > elementMiddle) {
                        $(this).addClass("revealed");
                    }
                }
            });
        };

        var throttledStatisticAnimationFunction = $.throttle(100, statisticAnimationFunction);

        $(window).on("scroll", function () {
            throttledStatisticAnimationFunction();
        }).trigger("scroll");

    })

})($JQ);
